module.exports = __webpack_public_path__ + "img/msft_seafarmstake.e4e182d.png";